// en_pms_personal_dashboard.ts
// Tłumaczenia dla PersonalDashboard.tsx

export const enPmsPersonalDashboard = {

  // ── Powitania ─────────────────────────────────────────────────────────────
  greetings: {
    morning:   "Good morning",
    afternoon: "Good afternoon",
    evening:   "Good evening",
  },

  // ── Sekcje widgety ────────────────────────────────────────────────────────
  sections: {
    liveActivity:   "Live activity",
    housekeepingQueue:"Housekeeping queue",
    openIncidents:  "Open incidents",
    handover:       "Handover",
    finance:        "Finance",
    activity:       "Activity",
    operations:     "Operations",
    maintenance:    "Maintenance",
    guests:         "Guests",
  },

  // ── Pasek narzędzi ────────────────────────────────────────────────────────
  toolbar: {
    customize: "Customize",
    done:      "Done",
    enter:     "Enter",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    arrivalToday:           "Arrival today",
    arrivalsToday:          "Arrivals today",
    assignedToHousekeeping: "Assigned to housekeeping",
    needsCleaning:          "Needs cleaning",
    occupancy:              "Occupancy",
    revenue:                "Revenue",
    openIssues:             "Open issues",
    noCriticalIssues:       "No critical issues",
    noPickupData:           "No pickup data",
    noRevenueData:          "No revenue data",
    noRevenueHistory:       "No revenue history",
    noLinkedIncident:       "No linked incident to assign",
    noLinkedIncidentResolve:"No linked incident to resolve",
  },

  // ── Przekazanie ───────────────────────────────────────────────────────────
  handover: {
    acknowledged: "Handover acknowledged",
    noteAdded:    "Handover note added",
    markedResolved:"Marked as resolved",
  },

} as const;

export default enPmsPersonalDashboard;
